import troubles from "./bs_en_troubles";
export default [
  [
    {
      q: "블루투스에서 내 차량을 찾을 수 없는 이유는 무엇입니까?",
      a:
        "1. 차량이 P(주차)모드인지 확인하십시오.<br/>\
        2. 휴대폰의 블루투스 기능을 다시 시도하거나 휴대폰의 블루투스 기능이 켜져 있는지 확인해 주십시오. (Android 10의 시스템 버그로 인해 Android 10 전화기 사용자는 위치정보 기능을 켜야 합니다.)<br/>\
      3. 차량이 연결대기 상태인지 확인하십시오.<br/>\
      차량의 안전을 보장하기 위해, 차량이 연결대기 상태에 들어간 후, 2분 이내에 조작이 없거나 차량 이동 및 운행 시 자동으로  연결 대기 상태를 종료합니다. 이로인해 블루투스  차량 검색이 불가능 할 수 있습니다. 일정 시간 내 앱에서 검색을 통해 차량을 다시 시동하고 활성화 과정을 완료할 수 있습니다."
    },
    {
      q:
        "검색된 차량을 연결하려면 클릭하십시오. 앱에서 연결이 실패했다고 표시됩니까?",
      a:
        "1.차량이 바인딩 보류 중인지 확인하십시오.<br/>\
        차량의 안전을 보장하기 위해 차량이 바인딩 상태에 들어간 후 5분 이내에 조작, 밀기 또는 운전이 없으면 차량이 자동으로 바인딩 상태를 종료하므로 차량이 연결할 수 없습니다.<br/>\
        차량을 다시 시작하고 특정 시간 내에 APP를 통해 검색하면 활성화 작업을 완료할 수 있습니다.<br/>\
        2.휴대폰의 블루투스 신호가 불안정하여 연결에 어려움이 있을 수 있습니다. 휴대폰의 블루투스 기능을 껐다가 켠 후 차량과 다시 연결을 시도할 수 있습니다."
    },

    {
      q:
        "차량이 여러 대 검색된 경우 대상 차량을 식별하려면 어떻게 해야 합니까?",
      a:
        "차대번호와 대조하여 활성화할 차가 어느 차인지 확인할 수 있습니다. 프레임 번호는 일반적으로 차량 시트의 충전 포트 근처 또는 아래와 같이 VIN이 인쇄된 위치에 있습니다.\
      <div style='text-align:center;padding-top:24px;'><img src='/static/img/q3.png' width='180px' alt=''></div>"
    },
    {
      q: "앱에 '차량 네트워크 활성화 중...'이라고 표시되면 어떻게 해야 합니까?",
      a:
        "1.차량의 네트워크 연결이 정상인지 확인하십시오.<br/>\
        차량 계기반에서 네트워크 상태를 확인할 수 있으며, 차량의 네트워크 상태가 좋지 않은 경우, 개방된 실외 환경이나 네트워크가 양호한 환경으로 차량을 이동하는 것이 좋습니다.<br/>\
      2.휴대폰의 네트워크 연결이 정상인지 확인하십시오.<br/>\
      네트워크가 비정상적이거나 불안정하여 활성화 상태가 제대로 동기화되지 않을 수 있습니다.<br/>\
      3.귀하의 블루샤크 앱의 '알림 권한'이 켜져 있는지 확인합니다. 설정메뉴의 → 알림 → 블루샤크 앱 → 알림설정 켜기(휴대폰 시스템 버전 차이에 의해 조작 프로세스의 차이가 있을 수 있습니다.)<br/>\
      4.앱을 다시 시작하거나 앱 로그인 계정에서 로그아웃했다가 다시 로그인하여 문제를 해결할 수 있습니다."
    },

    {
      q: "활성화 및 연결에 성공한 후 블루투스 연결 프로세스가 완료되었습니까?",
      a:
        "연동 활성화 이후 휴대폰과 차량간의 기본 통신을 위한 저전력 블루투스(BLE) 모듈 연결만 완료했습니다.<br/>\
        음악이나 전화 등 블루투스 관련 기능을 사용해야 하는 경우 설정으로 이동하여 휴대폰의 블루투스를 통해 차량을 연결하십시오."
    },

    {
      q: "차량 연결을 해제하려면 어떻게 해야 합니까?",
      a:
        "앱에 로그인하고, 사이드바에서 연결 해제하려는 차량을 선택하고 차량 삭제를 클릭하고 계약 삭제를 확인한 다음 삭제를 클릭하여 연결을 성공적으로 해제합니다."
    },
    {
      q:
        "앱에서 계정 연결을 해제한 후, 차량이 활성화 대기상태로 들어갈 수 없습니까?",
      a:
        "바인딩을 해제한 후 차량이 다시 바인딩 보류 상태로 들어갈 수 없다면 현재 차량의 네트워크 연결이 좋지 않기 때문일 수 있습니다.<br/>\
      1.네트워크가 양호한 개방된 환경으로 차량을 이동한 다음 차량을 다시 시작하여 상태를 확인할 수 있습니다.<br/>\
      2.차량의 스마트 서비스가 만료되었는지 확인합니다. 그렇다면 요금을 갱신한 다음 차량을 다시 시작하여 상태를 확인하세요.<br/>\
      * 일부 모델은 차량 설정 기능에 들어가 '바인딩 대기 모드' 모드를 찾아 능동적으로 차량을 바인딩 상태로 설정할 수 있습니다."
    }
  ],
  [
    {
      q: "휴대폰 번호 교체/해제는 어떻게 하나요?",
      a:
        "고객님의 계정 보안을 유지하기 위해 차량 활성화 후 휴대폰 번호를 반드시 연결해야 합니다. 차량 활성화에 사용된 계정은 직접 연동 해제가 불가하며 다른 휴대폰 번호로 변경만 가능합니다. <br/>\
        전화번호를 업데이트하려면 설정 페이지로 이동하여 계정 보안센터에 들어가 계정 링크를 관리한 다음 전화번호를 클릭하여 변경하십시오."
    },

    {
      q: "하나의 계정으로 여러개의 장치를 사용할 수 있습니까?",
      a:
        "계정 로그인은 모바일 장치에 제한되지 않습니다. 단, 계정 보안 및 차량 보안을 위해 동일한 계정을 여러 모바일 기기에서 동시에 사용할 수 없습니다. 그렇지 않으면 해당 계정은 다른 장치에서 자동으로 로그아웃됩니다."
    },

    {
      q: "계정 삭제하는 방법",
      a:
        "앱은 계정 삭제를 지원합니다. 그렇게 하기 전에, 이 계정에 연동된 차량이나 미지급 서비스가 없는지 확인해 주십시오.<br/>\
        설정 → 계정 보안 → 계정 삭제를 클릭하여 계정을 삭제할 수 있습니다. 작업을 취소할 수 없으므로 계정을 삭제하기 전에 주의하십시오. 삭제 후에는 로그인하거나 블루샤크 계정 관련 데이터에 액세스할 수 없습니다."
    },
    {
      q: "차량의 데이터 사용 권한을 관리하는 방법",
      a:
        "우리는 귀하의 개인 정보 보호를 매우 중요하게 생각합니다.<br/>\
        앱을 사용하여 차량 상태 보기, 차량 위치 지정, 위치 지정, 차량 동적 기록, 원격 제어 차량, 차량 설정 및 기타 기능을 실현할 수 있습니다.<br/>\
      '최소화' 원칙에 따라 귀하의 차량 위치 및 주행경로 정보를 직간접적으로 취득하여 암호화 처리합니다.<br/>\
      차량 관리 페이지에 접속하여 차량 데이터 및 권한 기능을 선택하여 권한을 관리할 수 있습니다. 기능이 비활성화된 후 일부 기능을 사용할 수 없게 될 수 있습니다."
    }
  ],
  [
    {
      q: "라이딩하기 전에 무엇을 준비해야 하나요?",
      a:
        "안전한 라이딩을 위해 다음과 같이 준비하시기 바랍니다.<br/>\
      1.차량의 전원이 정상적으로 켜져 있는지, 조명 및 기타 조건이 정상인지 점검한다.<br/>\
      2.전/후 브레이크가 정상적으로 작동하는지 점검하십시오.<br/>\
      3.타이어 공기압이 정상인지 확인합니다;<br/>\
      4.핸들 바, 전/후 휠이 잘 고정되어 있는지, 스티어링 잠금이 해제되어 있는지 확인합니다;<br/>\
      5.배터리 전력이 충분한지 확인합니다;<br/>\
      6.다른 고장 경고가 있는지 확인합니다.<br/>\
      7.헬멧과 기타 보호 장비를 착용하십시오."
    },

    {
      q: "차량 시동은 어떻게 거나요?",
      a:
        "다음과 같은 다양한 방법으로 차량을 시동할 수 있습니다.<br/>\
        1.리모콘 키: (1) 리모콘의 잠금 해제 버튼을 클릭합니다. (2) 리모컨 키를 가지고 가십시오. 차량에 가까워지면 전원 버튼(예: 전원 버튼 또는 준비 버튼)이 규칙적으로 깜박입니다. 차량을 시작하려면 길게 누르십시오.<br/>\
        2.앱: (1) 앱을 열고 '시작'을 클릭하여 차량을 시작합니다. (2) 차량이 휴대폰에 바인딩되어 있습니다. 차량이 차량에 가까워지면 전원 버튼(예: 전원 버튼 또는 준비 버튼)이 규칙적으로 깜박입니다. 차량을 시작하려면 길게 누르십시오.<br/>\
        3.지문 잠금 해제: 일부 모델에는 지문 인식 영역이 있어 키나 휴대폰 없이도 지문으로 차량 시동을 걸 수 있습니다."
    },
    {
      q:
        "차량 시동이 걸렸는데도 스로틀을  돌릴 때 가속을 할 수 없는 이유는 무엇입니까?",
      a:
        "주행 안전을 보호하고 과속과 같은 위험한 조건을 피하기 위해 차량에는 센서를 통한 출발에 대한 안전 제한이 있습니다.<br/>\
      타기 전에 사이드 스테이나 센터 스테이를 치우고 차량에 탑승해야 합니다.<br/>\
      그리고 오른쪽 핸들의 'READY' 버튼을 누르면 'READY' 표시등이 켜지고 차량은 승차 대기 상태로 들어갑니다. 이 시점에서 핸들바를 비틀어 차량에 전원을 공급할 수 있습니다.<br/>\
      위 기능은 일부 모델에서만 사용 가능하며, 모바일 APP의 차량 센터를 통해 켜고 끌 수 있습니다."
    },

    {
      q: "주행이 끝나면 어떻게 해야 하나요?",
      a:
        "목적지에 도착하면 'READY' 버튼을 눌러 READY 모드를 취소하고 측면 버팀대 또는 중간 버팀대를 내립니다.<br/>\
        다음과 같은 방법으로 차량을 잠글 수 있습니다.<br/>\
        1. 리모콘: 리모콘의 잠금 버튼을 클릭합니다.<br/>\
        2. 휴대폰: 모바일 앱을 열고 '잠금'를 클릭하여 차량을 잠급니다. <br/>\
        3. 차량 : 차량 매뉴얼의 안내에 따라 차량 핸들바의 물리적 버튼을 통해 강화합니다.<br/>\
        차량을 잠근 후 수도꼭지를 왼쪽으로 돌려 수도꼭지 잠금장치가 잠겼는지 확인하세요."
    }
  ],
  [
    {
      q: "전자식 사이드 킥 스탠드 감지 기능은 무엇입니까?",
      a:
        "안전을 보장하기 위해 전자식 사이드 스탠드 감지 기능 은 사이드 스탠드가 내려지거나 올라가는 상태를 감지합니다. 이 기능은 주행 준비가 되면 사이드 스탠드를 올리고 주행을 시작하라는 메시지를 표시합니다.<br/>\
        이 기능은 차량 OS 또는 앱 설정을 통해 켜거나 끌 수 있습니다. 초보 사용자는 이 기능을 유지하는 것이 좋습니다."
    },
    {
      q: "시트 압력 감지 기능은 무엇입니까?",
      a:
        "안전을 보장하기 위해 시트 압력 감지 기능(R1 모델의 경우 Easy Start 기능)은 차량에 사람이 타고 있는지 여부를 감지하는 데 사용됩니다. 이 기능은 운전할 준비가 되었을 때, 또는 운전을 시작하기 전에 시트에 앉도록 알려줍니다.<br/>\
        이 기능은 차량 OS 또는 앱 설정을 통해 켜거나 끌 수 있습니다. 초보 사용자는 이 기능을 유지하는 것이 좋습니다."
    },
    {
      q: "턴 어시스턴스 기능은 무엇입니까?",
      a:
        "안전을 보장하기 위해 조향 보조 기능은 방향전환 중에 후방 카메라를 작동시켜 뒤에 있는 도로 상태 정보를 제공하며 사각지대의 시야를 확보합니다.<br/>\
        (이 기능은 일부 모델에서만 지원됩니다.)"
    },

    {
      q: "후진 지원 기능은 무엇입니까?",
      a:
        "안전을 보장하기 위해 후진 중에 후방 카메라와 후방 초음파 레이더를 작동시켜 차량 후방의 장애물 및 장애물과의 거리를 표시함으로써, 사각지대를 줄여 줍니다.<br/>\
        (이 기능은 일부 모델에서만 지원됩니다.)"
    }
  ],
  [
    {
      q: "휴대 전화와 페어링 연동하는 방법은 무엇입니까?",
      a:
        "1. 차량을 안전하게 주차한 후 스마트 메뉴를 열고 블루투스 설정을 선택하십시오.<br/>\
      2. '휴대폰'을 선택하고 블루투스를 기능을 켜고 휴대폰 연결을 선택합니다.<br/>\
      3. 전화기의 블루투스 페이지로 이동하여 휴대폰을 찾을 수 있는지 확인합니다.<br/>\
      4. 차량에서 휴대폰을 선택하고 연동합니다.<br/>\
      5. 차량은 이전에 연결된 모바일 기기를 기억할 수 있으므로, 연결된 기기가 가까이 있으면 자동으로 차량에 연결할 수 있습니다. ( iOS 기기는 휴대폰 블루투스를 켰을때 메모리 기능을 지원하며, 안드로이드 기기는 휴대폰 블루투스에 영향을 받지 않습니다)<br/>\
      6. 장치와 연결을 끊으려면 차량에서 해당 장치를 선택하면 됩니다.<br/>\
      7. 차량이 휴대폰을 감지하지 못할 경우 휴대폰의 블루투스 기능이 켜져 있는지 확인하고 블루투스를 연결시켜 주세요. 그래도 차량을 찾을 수 없으면 블루투스를 껐다가 다시 켜주세요."
    },

    // {
    //   q: "如何连接蓝牙耳机或蓝牙头盔？",
    //   a:
    //     "（目前该功能仅支持R1 车型）<br/>\
    //   1.在车辆驻车状态下，打开智能菜单选择蓝牙设置功能；<br/>\
    //   2.选择“耳机/头盔”并开启蓝牙功能，选择您的设备名称并连接；<br/>\
    //   3.打开手机，并打开蓝牙页面，以保证手机设备可以被搜索到；<br/>\
    //   4.若要断开链接，选择断开相应的设备即可。"
    // },
    {
      q: "블루투스 음악 기능을 활성화하는 방법은 무엇입니까?",
      a:
        "1. 휴대폰과 헤드셋/헬멧이 차량에 연결되어 있는지 확인하십시오. 그렇지 않을 경우, 스피커를 통해 음악이 재생됩니다.<br/>\
      2. 휴대폰이 음악을 재생하기 시작하면, 주차모드 혹은 주행모드 상관없이 차량을 통해 바로 음악을 재생할 수 있습니다.<br/>\
      3. 차량의 재생/일시 정지 버튼을 사용하여 음악을 재생 및 일시 정지하고, OK 버튼을 눌러 다음 곡을 재생하고, 볼륨 버튼을 클릭하여 볼륨을 높이거나 줄일 수 있습니다."
    }

    // {
    //   q: "如何使用蓝牙电话功能？",
    //   a:
    //     "（目前该功能仅支持R1 车型）<br/>\
    //   1.在车辆驻车状态下，打开智能菜单选择蓝牙电话功能；<br/>\
    //   2.请确保车辆已经连接了您的手机和耳机/头盔，需要您耳机/头盔的麦克风进行通话。<br/>\
    //   3.选择“同步通讯录”，将手机的最近联系人和通话记录同步到车机上；<br/>\
    //   4.我们为您提供了“最近联系人”“所有通话”“未接来电”三个选项，你可以在驻车状态下进行外呼。<br/>\
    //   最近联系人：车辆读取手机通讯录中最近有过通话的10个人；<br/>\
    //   所有通话：车辆显示最近3天的通话记录（最多20条）；<br/>\
    //   未接来电：车辆在所有通话中筛选出所有未接来电（最多20条）；<br/>\
    //   5.若有人向你呼入通话，你可通过按车机上的OK键接通，或使用“返回”键挂断。"
    // }
  ],
  [
    {
      q: "차량 위치 확인에 관한 문제",
      a:
        "차량은 위성의 GPS 신호를 통해 위치를 파악합니다. 차량이 실내 또는 지하주차장 등 폐쇄된 공간에 있을 경우 차량 위치의 정확성에 영향을 미치며, 차량을 개방된 환경으로 이동하면 보다 정확한 GPS 위치추적 기능이 가능해집니다.<br/>\
      주행 궤적은 차량이 정해진 시간내에 기록되는 지점들이 연결되어 만들어진 주행궤적입니다.  잘못된 위치를 포착하거나 지점을 잃어버리는 상황이 발생 할 경우 비정상적인 주행궤적으로 표시 될 수 있습니다.<br/>\
      장기간 위치추적이 불가능하거나 궤적이 이상할 경우 차량 스마트 서비스가 만료됐는지 점검하고, 만료되지 않았을 경우 공식 서비스센터에서 차량 네트워크 및 GPS 상태를 점검할 수 있습니다."
    },

    {
      q: "메시지 알림에 관한 문제",
      a:
        "다음 지침에 따라 문제를 해결할 수 있습니다.<br/>\
      1.앱 홈페이지 오른쪽 상단에 있는 메시지 센터로 이동하여 '차량 진동'과 같은 푸시 메시지를 받을 수 있는지 확인하세요.<br/>\
      2.휴대전화의 알림 설정을 관리합니다. 설정 페이지로 이동하여 알림을 선택하고 앱을 선택한 다음 알림이 허용되어 있는지 확인하세요.<br/>\
      3.앱에서 차량을 선택하고 차량 보안 모드를 선택한 후 푸시 알림 허용 여부를 확인합니다."
    },

    {
      q: "차량 보안 모드는 무엇입니까?",
      a:
        "차량의 안전을 위해 차량의 진동, 휠 움직임, 배터리 분리, 배터리 과방전 등과 같은 비정상적인 이벤트를 알리는 알림이 발송됩니다.<br/>\
      차량이 주차된곳의 위험환경에 따라 경고 모드, 또는 방해 금지 모드를 선택하고 보안 설정을 사용자 가 지정할 수 있습니다.<br/>\
      차량이 움직이면 차량의 현재 위치를 확인하여 차량이 안전한지 확인할 수 있습니다."
    },

    {
      q: "예상 주행거리 계산이 정확하지 않은 문제",
      a:
        "차량 예상 주행거리는 사용자의 주행 습관과 해당 소비 전력을 기준으로 계산되며, 예상 주행 범위의 정확도는 적재물 상태, 도로 상황, 주변 온도 등 다양한 요인에 의해 영향을 받으며, 일반적으로 20% 정도의 편차는 정상입니다.<br/>\
        편차가 현저하게 크거나 작으면 일반적으로 배터리의 문제가 아니라 데이터 안정성이나 데이터 오류로 인한 문제이며, 여러번 주행한 후에도 편차가 크면 공식 서비스센터에 문의해 문제를 해결 하십시오."
    },

    {
      q: "차량 원격 제어에 반응이 없으면 어떻게 합니까?",
      a:
        "휴대전화의 네트워크가 정상인지 확인하고, 앱 홈페이지 우측 상단에서 블루투스와 네트워크 연결이 정상인지 확인해주세요. 인터넷이나 블루투스가 정상적으로 연결되어 있으면 리모컨 명령을 내릴 수 있습니다."
    }
  ],
  [
    {
      q: "차량 업그레이드의 목적은 무엇입니까?",
      a:
        "차량 OTA 업그레이드는 주로 차량 사용 경험을 개선하고 차량 기능을 최적화하기 위해 사용되며, 차량 OTA 업그레이드 시마다 기능 구성 요소를 알려드리며, 업그레이드 시마다의 내용은 업그레이드 당시 페이지를 참조하십시오."
    },
    {
      q: "차량 업그레이드를 위한 요구 사항은 무엇입니까?",
      a:
        " 1. 차량의 시동을 켜고 주차 상태인지 확인하십시오. 차량 배터리 잔량이 20% 이상인지 확인하십시오. 업그레이드 중에는 배터리를 제거하지 마십시오.<br/>\
      2. 휴대폰의 블루투스 및 휴대폰 네트워크가 켜져 있는지 확인하십시오. 차량에 가까이 접근하여 휴대폰과 차량을 연결하십시오."
    },

    {
      q: "업그레이드 과정에서 주의해야 할 점은 무엇입니까?",
      a:
        "1. 업그레이드 중에는 차량의 시동을 켜고  주행하지 마세요.<br/>\
      2. 업그레이드 중에는 차량에서 멀리 떨어지지 말고 차량과 휴대전화를 항상 연결해야 합니다.<br/>\
      3. 업그레이드 중에는 차량 배터리를 제거하지 마십시오.<br/>\
      4. 업그레이드 중에는 화면이나 앱을 끄지 말고 휴대전화의 네트워크와 블루투스를 켜주세요."
    },
    {
      q: "파일 전송이 중단되는 이유는 무엇입니까?",
      a:
        "차량 업그레이드 과정에서 휴대폰은 파일 전송을 위해 WiFi 네트워크를 통해 차량에 연결됩니다. 파일 전송 중에는 휴대폰이 네트워크 상태가 아닙니다. 파일 전송이 완료되면 휴대폰 네트워크가 복원됩니다.<br/>\
       일부 IOS 휴대전화 사용자는 사용자에게 현재 네트워크 상태가 좋지 않다고 알려줍니다. 네트워크 연결을 끊든 전환하든 현재 네트워크를 계속 사용하도록 선택하십시오.<br/>\
       일부 Android 휴대폰 사용자의 경우 네트워크를 자동으로 연결 해제하거나 전환하므로 최근 WLAN 선택 기능을 비활성화하십시오. 파일 전송이 완료된 후 활성화할 수 있습니다."
    },

    {
      q: "업그레이드는 끝났지만, 성공 여부를 모를시 어떻게 하나요?",
      a:
        "업그레이드 중에는 차량에서 멀리 떨어져 있지 마시고 블루투스 연결 상태를 유지하시기 바랍니다.<br/>\
        차량 업그레이드 과정에서 업그레이드 진행 상황과 상태는 차량 엔진 시스템과 앱 터미널에 각각 표시됩니다.<br/>\
      특수한 상황으로 인해 연결이 끊어진 경우 차량에 다시 연결을 시도할 수 있습니다. 또는 시스템 업그레이드 페이지를 새로고침하여 현재 차량 버전을 확인하십시오. 최신 버전이 표시되면 업그레이드가 성공한 것입니다. 일부 구성 요소가 최신 버전이 아닌 경우 다시 업그레이드하십시오."
    }
  ],
  [
    {
      q: "어떻게 배터리를 충전 하나요?",
      a:
        "차량은 다양한 충전 및 보충 모드를 지원합니다.<br/>\
      1.충전기:<br/>\
      충전 거치대를 평평한 표면에 놓고 환경 온도가 너무 높거나 낮지 않고 습기가 없는지 확인하세요. 직접 충전 충전기를 전원 공급 장치에 연결한 다음 충전 거치대를 직접 충전 충전기에 연결하고 배터리를 거치대에 올바르게 올려놓으면 충전이 시작됩니다. 2개의 배터리를 동시에 충전해야 하는 경우 스플리터를 충전기와 2개의 충전 거치대에 각각 연결하세요.<br/>\
      충전대는 직접 충전 충전기와 함께 사용해야 합니다.<br/>\
      2.직접 충전:<br/>\
      배터리가 안에 있는 동안 차량을 충전할 수 있습니다. 전원 공급 장치를 충전 커넥터에 연결하면 배터리가 꽉 찼는지 화면을 통해 알 수 있습니다.<br/>\
      3.BSS:<br/>\
      영역의 일부는 교환 서비스를 열어 BSS를 통해 변경할 수 있는 BSS의 충전 네트워크를 포함합니다."
    },
    {
      q: "배터리 사용 시 주의할 사항은 무엇입니까?",
      a:
        "1.배터리 작동 환경:<br/>\
        -10~45℃;<br/>\
        액체에 담그지 마십시오;<br/>\
        배터리함에 금속 및 이물질이 들어가지 않도록 하십시오.<br/>\
        인화성 및 폭발성 물체 근처에 배터리를 놓지 마십시오.<br/>\
      2. 배터리 용량 감소 :<br/>\
      저온 조건에서는 배터리의 가용 용량이 다양한 정도로 감소됩니다. 기준 값은 다음과 같습니다.<br/>\
      온도가 -10℃일 때 배터리의 사용 가능 용량은 약 70%이다.<br/>\
      0 ℃, 약 85%;<br/>\
      25 ℃, 약 100%;<br/>\
      3. 배터리 안전 주의사항:<br/>\
      배터리가 뜨거워지거나 변질되거나 냄새가 나면 즉시 사용을 중지하고 배터리로부터 멀리 떨어지십시오. 공식 서비스 센터에 연락하여 점검 및 수리를 받으시기 바랍니다. 배터리를 직접 분해하지 마십시오. 배터리를 무단으로 분해할 경우 화재, 폭발 등의 사고가 발생할 수 있으며, 배터리 보증이 무효화됩니다."
    },

    {
      q: "배터리 수명을 연장하는 방법",
      a:
        "배터리의 수명은 주로 충전주기와 저장환경에 따라 결정되며, 충전주기는 100% 충전된 배터리를 완전히 방전시켜 다시 충전하는 과정을 말합니다. 올바른 사용 습관의 경우, 사용 한 즉시 자주 충전해야 하며, 0~25℃의 건조한 환경에서 50% 배터리 잔량 수준으로 보관, 그리고 과열을 피하는 것이 좋습니다. 과방전 혹은 완전 방전을 하지 않는것이 배터리 수명 연장에 좋습니다."
    }
  ],
  [
    {
      q: "차량 유지 관리 지침",
      a:
        "1.정기점검 실시<br/>\
        정기적인 유지 보수는 차량의 서비스 수명을 효과적으로 연장할 수 있습니다. 사용자는 차량 시스템 또는 앱의 알림에 따라 차량을 정기적으로 유지할 수 있습니다.<br/>\
        정기적인 정비를 하지 않으면 차량에 안전상의 위험이 있어 오작동이나 사고가 발생할 수 있으며, 정비 과정에서 차량에 이상이 발견되면 지정 매장이나 공식 서비스센터로 가져가 점검 및 수리를 받으시기 바랍니다.<br/>\
      2.유지보수 방법 매뉴얼에 주요 점검 항목이 몇 가지 소개되어 있습니다. <br/>\
      보다 철저한 점검을 위해서는 지정 매장 또는 공식 서비스센터로 가거나, 블루샤크 애프터서비스 매뉴얼에 따라 정비를 실시하여 주시기 바랍니다.<br/>\
      정기 유지 관리 시 주의하여 다음 지침을 준수하십시오.<br/>\
      정기적인 유지보수를 수행하기 전에, 넓은 안전한 공간을 선택하고 차량의 메인 스탠드를 내린 다음 차량 유지보수를 시작하십시오.<br/>\
      장거리 주행 후 차량의 일부 전자 부품이 뜨거워질 수 있습니다. 손상을 방지하기 위해 즉시 부품을 분해하지 마십시오.<br/>\
      정기정비 중 차량에 이상이 발견되면 조속히 적절히 조취해 주시고, 스스로 이상이 발견되면 지정 매장이나 공식 서비스센터로 가셔서 점검하시기 바랍니다."
    }
  ],
  [
    {
      q: "차량의 시동이 켜지지 않을 시 어떻게 하나요?",
      a:
        "1단계:<br/>\
        전원 스위치가 켜져 있는지 확인하고, 켜져 있지 않은 경우 차량의 전원 스위치를 켜십시오;<br/>\
        2단계:<br/>\
        리모컨의 배터리가 다 되었는지 확인합니다. 리모컨 키의 표시등이 꺼졌는지 깜박이는지 확인할 수 있습니다. 꺼져 있으면 배터리를 교체하십시오. <br/>\
        3단계:<br/>\
        차량 배터리가 삽입되었는지 확인하십시오. 삽입되지 않은 경우 충분한 전력을 가진 배터리를 삽입하십시오. 배터리가 부족하면 지침에 따라 충전하십시오.<br/>\
        위의 방법을 시도해도 시동이 걸리지 않을 경우 지정된 매장이나 서비스센터에 연락하여 점검 및 수리를 받으시기 바랍니다."
    },

    {
      q: "충전 후 주행 거리가 짧아지는 이유는 무엇입니까?",
      a:
        "1단계:<br/>\
        타이어 손상 또는 타이어 공기압 부족 여부를 점검하십시오. 타이어가 손상되면 타이어를 교체하거나 공기를 주입하십시오.<br/>\
        2단계:<br/>\
        낮은 주행 환경 온도가 배터리 방전 효율에 영향을 미치므로 차량의 환경 온도가 너무 낮은지 점검하십시오. 이는 정상적인 현상입니다. 충전 환경이 5~55º인지 확인하십시오. <br/>\
        3단계:<br/>\
        배터리 충전 시간이 너무 짧은지 점검하십시오. 충전 플러그가 올바르게 연결되어 있는지 확인하십시오.<br/>\
        * 배터리를 여러 번 충전 및 방전한 후에는 배터리의 총 용량이 어느 정도 감소될 수 있습니다. 이는 정상적인 현상입니다.<br/>\
        위의 조건을 확인 후에도 문제가 여전히 존재하는 경우, 해당 차량을 지정된 매장이나 서비스 센터로 가져가 점검 및 수리를 받으시기 바랍니다."
    },

    {
      q: "충전중에 충전기에서 열이 발생하는 현상",
      a:
        "일반적으로 충전과정에서 충전기 온도가 올라가는것은 정상적인 현상입니다.<br/>\
      충전기가 뜨거워져 손으로 만질 수 없을 경우 즉시 전원을 차단해 충전을 중지하고, 충전기를 지정된 매장이나 공식 서비스센터로 보내 점검·수리를 받으시기 바랍니다."
    },
    { q: "고장 코드 및 처리 의견", a: troubles }
  ]
];



// WEBPACK FOOTER //
// ./src/assets/js/helpMultilngual/bs_kr_questions.js